import ModelUtil from '@leverege/model-util';
import { Attributes } from '@leverege/ui-attributes';
const TYPE = 'filter.groupedText.field';
function toImagineFilter(value, objType) {
  const attr = Attributes.getAttribute(value.attrName, objType);
  if (Array.isArray(value?.filter)) {
    return value.filter.map(f => ({
      field: attr?.blueprint?.field,
      filter: f
    }));
  }
  if (value?.filter) {
    return {
      field: attr?.blueprint?.field,
      filter: value.filter
    };
  }
  return attr?.blueprint?.field;
}
function create({
  attrName,
  displayName,
  filter
} = {}) {
  return {
    type: TYPE,
    attrName,
    displayName,
    filter
  };
}
export default {
  TYPE,
  type: TYPE,
  create,
  ...ModelUtil.createAllValue('attrName'),
  ...ModelUtil.createAllValue('displayName'),
  // unused for now
  ...ModelUtil.createAllMap('filter'),
  toImagineFilter
};

// { type : 'filter.groupedText.field', attrName : evt?.value?.attr?.name, displayName : evt?.value?.attr?.displayName }